//import Vue from 'vue/dist/vue.js'
import Vue from "vue";
import Vuex from 'vuex'
import axios from 'axios'
import optionListener from '@/whatchat/utils/optionMenuListener'
import getIndexes from '@/whatchat/helpers/getIndexes'
import { Action, Mutation, Urls_, setItemsStorage, clearStorage, TOKEN_KEY, API_URL } from '@/whatchat/index'
// import 'babel-polyfill'
import { Socket, Presence } from 'phoenix'
import moment from 'moment'
// import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
window.Presence = Presence

const syncPresentUsers = (context, presences) => {
    const participants = []
    Presence.list(presences).map(p => {
        const participant = p.metas[0]
        if (context.getters.getCurrentUser.id !== participant.id) {
            // const channel = socket.channel(`chat:${auth}:`);
            participants.push(participant)
        }
    })
    context.dispatch('loadOnlineUsers', participants)
}

const getDefaultState = () => {
    return {
        appLoaderVisible: false, // Loader
        token: localStorage.getItem(TOKEN_KEY) || '', // Auth state
        status: '',
        currentUser: null,
        socket: null,
        channel: null,
        channelUser: null,
        currentConversation: null, // The current conversation opened : It's a participant
        AllContacts: [],
        OnlineUsers: [],
        conversations: [],
        contactLoader: false,
        conversationLoader: false,
        playSounds: true,
    }
  }

const store = new Vuex.Store({
    // plugins: [createPersistedState()],
    strict: process.env.NODE_ENV !== 'production',
    state: getDefaultState(),
    getters: {
        // Auth getters
        playSounds: state => state.playSounds,
        isAuthenticated: state => !!state.token,
        authStatus: state => state.status,
        isProcessing: state => state.appLoaderVisible,
        getCurrentUser: (state) => {
            return state.currentUser
        },
        getSocket: (state) => {
            return state.socket
        },
        getChannel: (state) => {
            return state.channel
        },
        getOnlineUsers: (state) => (filterName, filterValue) => {
            switch (filterName) {
                case 'all':
                    return state.OnlineUsers

                // Bring back one contact
                case 'one':
                    return state.OnlineUsers.find((participant) => {
                        return participant.id === filterValue
                    })

                case 'ordered':
                    switch (filterValue) {
                        case 'asc':
                            return state.OnlineUsers.sort((participantA, participantB) => {
                                return participantA.username.toLowerCase() > participantB.username.toLowerCase() ? 1 : -1
                            })
                        case 'desc':
                            return state.OnlineUsers.sort((participantA, participantB) => {
                                return participantA.username.toLowerCase() < participantB.username.toLowerCase() ? -1 : 1
                            })
                        default:
                    }
                    break

                default:
                    return state.OnlineUsers
            }
            return state.OnlineUsers
        },
        filteredAllContacts: (state) => (filterName, filterValue) => {
            switch (filterName) {
                case 'all':
                    return state.AllContacts

                // Bring back one contact
                case 'one':
                    return state.AllContacts.find((participant) => {
                        return participant.id === filterValue
                    })

                case 'ordered':
                    const list = state.AllContacts.filter(contact => {
                        return contact.id !== state.currentUser.id
                    })
                    switch (filterValue) {
                        case 'asc':
                            return list.sort((participantA, participantB) => {
                                return participantA.username[0].toLowerCase() > participantB.username[0].toLowerCase() ? 1 : -1
                            })
                        case 'desc':
                            return list.sort((participantA, participantB) => {
                                return participantA.username[0].toLowerCase() < participantB.username[0].toLowerCase() ? -1 : 1
                            })
                        default:
                            return list.sort((participantA, participantB) => {
                                return participantA.username[0].toLowerCase() > participantB.username[0].toLowerCase() ? 1 : -1
                            })
                    }

                default:
                    return state.AllContacts
            }
        },
        currentConversation(state) {
            let indexConv = -1
            indexConv = state.conversations.findIndex(conversation => {
                return conversation.id === state.currentConversation
            })
            if (indexConv !== -1) {
                return state.conversations[indexConv]
            }
            return null
        },
        conversations: (state) => (filter, filterSearch) => {
            // Having at l
            let listConv = state.conversations
            switch (filter) {
                // Conversation having at least one message
                case 'atLeastOneMessage':
                    return state.conversations.filter(conv => {
                        return conv.is_group || (!conv.is_group && conv.messages.length > 0)
                    })

                case 'chats':
                    return listConv.filter(conv => {
                        return !conv.is_group
                    }).sort((convA, convB) => {
                        const user1 = convA.users.filter(user => { return user.id !== state.currentUser.id })[0]
                        const user2 = convB.users.filter(user => { return user.id !== state.currentUser.id })[0]
                        return user1.username[0].toLowerCase() > user2.username[0].toLowerCase() ? 1 : -1
                    })

                case 'search_chats_groups':
                    return listConv.filter(conv => {
                        if (conv.is_group) {
                            return conv.name.toUpperCase().indexOf(filterSearch) > -1
                        } else {
                            const user = conv.users.filter(user => { return user.id !== state.currentUser.id })[0]
                            return user.username.toUpperCase().indexOf(filterSearch) > -1
                        }
                    }).sort((convA, convB) => {
                        const user1 = convA.users.filter(user => { return user.id !== state.currentUser.id })[0]
                        const user2 = convB.users.filter(user => { return user.id !== state.currentUser.id })[0]
                        return user1.username[0].toLowerCase() > user2.username[0].toLowerCase() ? -1 : 1
                    })

                case 'all':
                    return listConv.sort((convA, convB) => {
                        return new Date(convA.latestMessage.inserted_at) - new Date(convB.latestMessage.inserted_at) < 0 ? 1 : -1
                    })

                default:
                    return listConv.filter(conv => {
                        return conv.messages.length > 0
                    }).sort((convA, convB) => {
                        return new Date(convA.latestMessage.inserted_at) - new Date(convB.latestMessage.inserted_at) < 0 ? 1 : -1
                    })
            }
        }
    },
    mutations: {
        // Auth mutators
        [Mutation.AUTH_SUCCESS]: (state, user) => {
            state.token = user.token;
            state.currentUser = user;
        },
        [Mutation.CLEAR_AUTH]: (state) => {
            state.token = null;
            state.currentUser = null;
            Object.assign(state, getDefaultState());
        },
        [Mutation.AUTH_ERROR]: (state) => {
            state.status = 'error';
        },
        [Mutation.HIDE_LOADER]: (state) => {
            state.appLoaderVisible = false;
        },
        [Mutation.SHOW_LOADER]: (state) => {
            state.appLoaderVisible = true
        },
        MODIFY_PLAYSOUNDS (state) {
            state.playSounds = !state.playSounds
        },
        // End of Auth mutators
        SET_ONLINE_USERS: function (state, { OnlineUsers }) {
            state.OnlineUsers = OnlineUsers
        },
        addAllContacts: function (state, { AllContacts }) {
            if (state.currentUser) {
                state.AllContacts = AllContacts.filter(function (conversation) {
                    return (conversation.id !== state.currentUser.id)
                })
            }
            // state.AllContacts = obj
        },
        // Add new discussion
        ADD_DISCUSSION: function (state, { discussion }) {
            const index = getIndexes.getElementIndex(state.conversations, discussion.id)
            // console.log(discussion)
            // If not existing discussion
            // Then we add
            if (index === -1) {
                discussion.typing_user = null
                discussion.count = discussion.messages.length
                let latestMessage = {
                    id: 1000,
                    content: '',
                    from_id: null,
                    inserted_at: moment(discussion.inserted_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
                }

                // Setting count unread message to 0 by default
                discussion.unread = 0

                const userPos = getIndexes.getElementIndex(discussion.users, state.currentUser.id)
                let me = null
                if (userPos !== -1) {
                    me = discussion.users[userPos]
                    me.read_at = moment(me.read_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
                }

                // If there are mesages in discussion
                if (discussion.messages.length > 0) {
                    discussion.messages.forEach(message => {
                        message.content = message.content.replaceAll("","'");
                        // fill writer names
                        var last_writer = null;
                        discussion.messages.forEach(function(message, index) {
                            const writer = discussion.users.filter(obj => {
                            return obj.id === discussion.messages[index].from_id
                        })[0].username;
                        if (writer !== last_writer) {
                            discussion.messages[index].from_name = writer + ':';
                            last_writer = writer;
                        } else
                            discussion.messages[index].from_name = '';  
                        });

                        message.inserted_at = moment(message.inserted_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
                        message.readers = {}
                        message.count_readers = 0

                        // get unread messages
                        const userPos = getIndexes.getElementIndex(discussion.users, state.currentUser.id)
                        if (userPos !== -1) {
                            if (moment.min(message.inserted_at, me.read_at) !== message.inserted_at)
                                discussion.unread += 1
                        }
                        
                        discussion.users.forEach(user => {
                            //user.inserted_at = moment(user.inserted_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
                            if (message.from_id === state.currentUser.id && user.id != state.currentUser.id) {
                                if (user.read_at) {
                                    let read_at = moment(user.read_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
                                    if (moment.min(message.inserted_at, read_at) === message.inserted_at) {
                                        message.readers[user.id] = { reader_id: user.id, reading_time: read_at }
                                        message.count_readers += 1
                                    }
                                }
                            }
                            else if (user.id == state.currentUser.id)
                                message.count_readers += 1 // myself


                            // // If it's someone message
                            // if (user.id !== state.currentUser.id) {
                            //     const userPos = getIndexes.getElementIndex(discussion.users, state.currentUser.id)
                            //     if (userPos !== -1) {
                            //         const me = discussion.users[userPos]
                            //         me.read_at = moment(me.read_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
                            //         if (moment.min(message.inserted_at, me.read_at) !== message.inserted_at) {
                            //             console.log('unread')
                            //             discussion.unread += 1
                            //         }
                            //     }
                            // }
                        })
                    })

                    // Messages are sorted by date
                    discussion.messages.sort((message1, message2) => {
                        // return moment.min(message1.inserted_at , message2.inserted_at ) === message1.inserted_at  ? true :false
                        return moment.min(message1.inserted_at, message2.inserted_at) !== message1.inserted_at ? 1 : -1
                    })

                    // We get the last posted message of the discussion
                    latestMessage = discussion.messages[discussion.count - 1]
                }
                // Else : no msg
                discussion.latestMessage = latestMessage

                // Adding
                state.conversations.push(discussion)
            }
        },
        SET_DISCUSSION: function (state, { participant }) {
            const index = state.participants.findIndex((element) => {
                return element.id === participant.participant.id
            })
            if (index === -1) {
                state.participants.push(participant.participant)
            }
        },
        // edit a participant
        EDIT_PARTICIPANT: function (state, { participant }) {
            state.participants = state.participants.filter((element) => {
                if (element.id === participant.id) {
                    element = participant
                }
                return true
            })
        },
        // Delete one participant
        REMOVE_PARTICIPANT: function (state, { participant }) {
            state.participants = state.participants.filter((element) => {
                return (element.id !== participant.id)
            })
        },
        SET_CURRENT_USER: function (state, user) {
            state.currentUser = user
        },
        // Current Conversing With
        SET_OPENED_DISCUSSION(state, { discussions_id }) {
            // console.log(discussions_id);
            state.currentConversation = discussions_id

            /* const discussionPosition = getIndexes.getElementIndex(state.conversations, discussions_id)
            if(discussionPosition !== -1){
              state.conversations[discussionPosition].unread = 0
            } */
        },
        SET_CLOSED_DISCUSSION(state) {
            state.currentConversation = null
        },
        // Reinit conv count unreads
        REINIT_CONVERSATION_UNREAD(state, { discussion_id }) {
            const discussionPosition = getIndexes.getElementIndex(state.conversations, discussion_id)
            if (discussionPosition !== -1) {
                state.conversations[discussionPosition].unread = 0
            }
        },
        // Mark a conversation as readed
        MARK_CONVERSATION_AS_READ(state, { discussion_id, user_id, read_at }) {
            let indexConv = state.conversations.findIndex(conversation => {
                return conversation.id === discussion_id
            })

            if (indexConv === -1)
                return

            let conversation = state.conversations[indexConv]
            let index = 0

            for (index; index < conversation.messages.length; index++) {
                if (conversation.messages[index].from_id === state.currentUser.id &&
                    conversation.messages[index].count_readers < conversation.users.length &&
                    typeof conversation.messages[index].readers[user_id] === 'undefined') {
                        let obj = { reader_id: user_id, reading_time: moment(read_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours') };
                        conversation.messages[index].readers[user_id] = obj;
                        conversation.messages[index].count_readers += 1
                }
            }
            conversation.latestMessage = conversation.messages[conversation.messages.length - 1]
        },
        // Adding message to discussion
        ADD_MESSAGE_TO_DISCUSSION(
            state,
            {
                discussion_id,
                message
            }) {
            const discussionPosition = getIndexes.getElementIndex(state.conversations, discussion_id)
            // If there is a problem with message discusion
            if (!message || discussionPosition < 0)
                return

            const messagePosition = getIndexes.getElementIndex(state.conversations[discussionPosition].messages, message.id)
            // Message already exist
            if (messagePosition > -1)
                return

            const discussion = state.conversations[discussionPosition]

            if (state.playSounds && state.currentUser.id !== message.from_id && state.currentConversation !== message.conversation_id) {
                discussion.unread++
                getIndexes.myMessageNotifer(`${API_URL}/sounds/chat_alertshort.mp3`)
            }
            message.readers = {}
            message.count_readers = 0
            message.inserted_at = moment(message.inserted_at).add(-(new Date().getTimezoneOffset()) / 60, 'hours')
            message.content = message.content.replaceAll("","'");
            
            if (message.from_id === state.currentUser.id) {
                message.readers[state.currentUser.id] = { user_id: state.currentUser.id, read_at: message.inserted_at }
                message.count_readers += 1
            }
            else {
                var last_writer_id = -1;
                if (discussion.messages.length - 1 >= 0)
                    last_writer_id = discussion.messages[discussion.messages.length - 1].from_id;
                var writer = discussion.users.filter(obj => {
                    return obj.id === message.from_id
                })[0];

                if (writer.id !== last_writer_id) {
                    message.from_name = writer.username + ':';
                    last_writer_id = message.id;
                } else
                    message.from_name = '';  
            }

            discussion.count++
            discussion.latestMessage = Object.assign({}, message)

            discussion.messages.push(message)

            state.conversations.splice(discussionPosition, 1)
            state.conversations.splice(0, 0, discussion)
            /*  state.conversations.sort((convA, convB) => {
                return new Date(convA.latestMessage.inserted_at) - new Date(convB.latestMessage.inserted_at) ? 1 : -1
              }) */
        },
        // Adding typing user flag
        ADD_TYPING_USER(state, { discussion_id, user_id }) {
            const discussionPosition = getIndexes.getElementIndex(state.conversations, discussion_id)
            const userPosition = getIndexes.getElementIndex(state.OnlineUsers, user_id)
            if (discussionPosition !== -1 && userPosition !== -1) {
                state.conversations[discussionPosition].typing_user = state.OnlineUsers[userPosition].username + ' is typing...'
            }
        },
        // Adding typing user flag
        REMOVE_TYPING_USER(state, { discussion_id, user_id }) {
            const discussionPosition = getIndexes.getElementIndex(state.conversations, discussion_id)
            const userPosition = getIndexes.getElementIndex(state.OnlineUsers, user_id)
            if (discussionPosition !== -1 && userPosition !== -1) {
                state.conversations[discussionPosition].typing_user = null
            }
        },
        SORT_DISCUSSIONS(state) {
            state.conversations.sort((convA, convB) => {
                return new Date(convA.latestMessage.inserted_at) - new Date(convB.latestMessage.inserted_at) < 0 ? 1 : -1
            })
        }
    },
    actions: {
        // Auth actions
        /**
         * Authenticate user
         */
        [Action.AUTH_REQUEST]: ({ commit, dispatch }, creds) => {
            return new Promise((resolve, reject) => { // The Promise used for router redirect in login
                commit(Mutation.SHOW_LOADER)
                axios({ url: Urls_.LOGIN_URL, data: creds, method: 'POST' })
                    .then(resp => {
                        const user = resp.data.user
                        // store the token in localstorage
                        setItemsStorage(user)
                        commit(Mutation.AUTH_SUCCESS, user)
                        dispatch('loadingConversationsThreads')
                        commit(Mutation.HIDE_LOADER)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit(Mutation.AUTH_ERROR, err)
                        commit(Mutation.HIDE_LOADER)
                        // if the request fails, remove any possible user token if possible
                        clearStorage()
                        reject(err)
                    })
            })
        },
        [Action.AUTH_LOGOUT]: ({ commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                commit(Mutation.SHOW_LOADER)
                axios({ url: Urls_.SIGNOUT_URL, data: null, method: 'DELETE' }).then(resp => {
                    clearStorage() // clear your user's token from localstorage
                    commit(Mutation.CLEAR_AUTH)
                    window.socket.disconnect()
                    commit(Mutation.HIDE_LOADER)
                    resolve()
                })
                    .catch(err => {
                        clearStorage() // clear your user's token from localstorage
                        commit(Mutation.CLEAR_AUTH)
                        commit(Mutation.HIDE_LOADER)
                        reject(err)
                    })
            })
        },
        [Action.AUTH_SIGNUP]: ({ commit, dispatch }, user_info) => {
            return new Promise((resolve, reject) => {
                commit(Mutation.SHOW_LOADER)
                axios({ url: Urls_.REGISTRATION_URL, data: user_info, method: 'POST' })
                    .then(resp => {
                        const user = resp.data.user
                        // store the token in localstorage
                        setItemsStorage(user)
                        dispatch('loadingConversationsThreads')
                        commit(Mutation.HIDE_LOADER)
                        commit(Mutation.AUTH_SUCCESS, user.token)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit(Mutation.AUTH_ERROR, err)
                        commit(Mutation.HIDE_LOADER)
                        // if the request fails, remove any possible user token if possible
                        clearStorage()
                        reject(err)
                    })
            })
        },
        [Action.AUTH_PING_CURRENT_USER_URL]: ({ commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                commit(Mutation.SHOW_LOADER)
                axios({ url: Urls_.PING_CURRENT_USER_URL, method: 'GET' })
                    .then(resp => {
                        const user = resp.data.user
                        // store the token in localstorage
                        setItemsStorage(user)
                        commit(Mutation.AUTH_SUCCESS, user)
                        dispatch('loadingConversationsThreads')
                        commit(Mutation.HIDE_LOADER)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit(Mutation.AUTH_ERROR, err)
                        commit(Mutation.HIDE_LOADER)
                        // if the request fails, remove any possible user token if possible
                        clearStorage()
                        reject(err)
                    })
            })
        },
        loadingConversationsThreads: async function (context) {

            async function createChannelDiscussion(context, discussion) {
                await context.dispatch('addDiscussion', discussion)
                const channelDiscussion = await window.socket.channel(`conversation:${discussion.id}`)
                if (channelDiscussion.state !== 'joined') {

                    channelDiscussion.join().receive('ok', async (response) => {
                        // The user receive a new message || When the user send a message
                        channelDiscussion.on('conversation:alert:new_messages', async response => {
                            let message = response.message

                            await context.commit('ADD_MESSAGE_TO_DISCUSSION',
                                { discussion_id: message.conversation_id, message: message })
                            // Marked as read when the message discussion is opened
                            if (context.state.currentConversation === message.conversation_id) {
                                // channelDiscussion.push("conversation:mark_read_messages")
                                context.dispatch('markConversationAsReaded', { discussion_id: context.state.currentConversation })
                            }
                        })
    
                        channelDiscussion.on('conversation:hey_someone_read_messages', async response => {
                            if (response.user_id !== context.getters.getCurrentUser.id) {
                                const discussionPosition = getIndexes.getElementIndex(context.state.conversations, response.discussion_id)
                                if (discussionPosition !== -1) {
                                    response.discussion_index = discussionPosition
                                    context.commit('MARK_CONVERSATION_AS_READ',
                                        response
                                    )
                                }
                            }
                        })
    
                        channelDiscussion.on('conversation:hey_someone_is_typing', async response => {
                            if (response.user_id !== context.getters.getCurrentUser.id) {
                                await context.commit(
                                    'ADD_TYPING_USER',
                                    { discussion_id: discussion.id, user_id: response.user_id })
                            }
                        })
    
                        channelDiscussion.on('conversation:hey_someone_remove_typing', response => {
                            if (response.user_id !== context.getters.getCurrentUser.id) {
                                context.commit('REMOVE_TYPING_USER',
                                    { discussion_id: discussion.id, user_id: response.user_id })
                            }
                        })
    
                        channelDiscussion.on('users:newConversation', response => {
                            // if (response.user_id !== context.getters.getCurrentUser.id) {
                            //     context.commit('REMOVE_TYPING_USER',
                            //         { discussion_id: discussion.id, user_id: response.user_id })
                            // }
                        })
                    })
                    // console.log(channelDiscussion)
                    window.channelDiscussion[discussion.id] = channelDiscussion
                }
            }

            context.commit(Mutation.SHOW_LOADER)
            let presences = {}

            const socket = await new Socket(Urls_.SOCKETS_URL, {
                params: {
                    token: context.state.token
                }
            })

            socket.connect()
            const channel = socket.channel(`users:join`)

            channel.on('presence_diff', (response) => {
                presences = Presence.syncDiff(presences, response)
                if (this.getters.getCurrentUser) {
                    syncPresentUsers(this, presences)
                }
            })

            channel.on('presence_state', (response) => {
                presences = Presence.syncState(presences, response)
                if (this.getters.getCurrentUser) {
                    syncPresentUsers(this, presences)
                    optionListener.menuListener()
                }
            })

            const channelUser = socket.channel(`users:${context.getters.getCurrentUser.id}`)

            channelUser.on('new_conversation', (discussion) => {
                createChannelDiscussion(context, discussion)
            })

            if (channelUser.state !== 'joined') {
                channelUser.join().receive('ok', async (response) => {
                }).receive('error', (response) => {
                })
            }

            if (channel.state !== 'joined') {
                channel.join().receive('ok', (response) => {
                    window.socket = socket
                    // Getting my discussions
                    window.channelDiscussion = {}

                    response.discussions.forEach(async function (discussion) {
                        createChannelDiscussion(context, discussion)
                    })

                    context.commit('SORT_DISCUSSIONS')
                }).receive('error', (response) => {
                })
            } else
                this.$router.push("{name: 'logout'}")

            context.commit(Mutation.HIDE_LOADER)
        },
        loadOnlineUsers: async function (context, OnlineUsers) {
            await context.commit('SET_ONLINE_USERS', { OnlineUsers })
        },
        addDiscussion: async function (context, discussion) {
            context.commit('ADD_DISCUSSION', { discussion: discussion })
        },
        removeDiscussion: async function (context, id_discussion) {
            context.commit('REMOVE_DISCUSSION', {
                discussion: id_discussion
            })
        },
        editDiscussion: async function (context, id_discussion) {
            context.commit('EDIT_DISCUSSION', {
                discussion: id_discussion
            })
        },
        // CurrentConversation | Chat opened
        setOpenedConversation: async function (context, discussions_id) {
            await context.commit('SET_OPENED_DISCUSSION', { discussions_id })
            context.dispatch('markConversationAsReaded', { discussion_id: discussions_id })
        },
        setClosedConversation: async function (context) {
            await context.commit('SET_CLOSED_DISCUSSION')
        },
        loadAllContacts: async function (context) {
            return axios.get(Urls_.REGISTRATION_URL)
        },
        addAllContacts: async function (context, { AllContacts }) {
            context.commit('addAllContacts', { AllContacts: AllContacts })
        },
        async markConversationAsReaded(context, { discussion_id }) {
            const discussionPosition = getIndexes.getElementIndex(context.state.conversations, discussion_id)
            if (discussionPosition !== -1) {
                const discussion = context.state.conversations[discussionPosition]

                //if (discussion.unread > 0) {
                    await window.channelDiscussion[discussion.id].push('conversation:mark_read_messages', { discussion_id: discussion.id })
                    context.commit('REINIT_CONVERSATION_UNREAD', { discussion_id: discussion_id })
                //}
            }
        },
        modifyPlaySounds: (context) => {
            context.commit('MODIFY_PLAYSOUNDS')
        },
    }
})

export default store